import 'scss/services/printed-word-recognition.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).data('packageId')
    let params = {
      wareId: '1109',
      packageId: packageId,
      serviceName: '印刷文字识别（多语种）intsig',
      businessId: 'recognize_document'
    }
    goServiceBuy(params)
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/printed-word-recognition.js